module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pane-header__search"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Search"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "pane-header__search__icon",
    attrs: {
      "src": require('../../assets/icons/icon-search.svg'),
      "alt": ""
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21d943de","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/universal/PaneHeaderSearch.vue
// module id = 432
// module chunks = 1